import { Component, PLATFORM_ID, Inject, OnInit } from '@angular/core';
import { isPlatformServer } from '@angular/common';
// libs
import { Store } from '@ngrx/store';
import { IAppState } from '../ngrx';
import * as UserActions from '../ngrx/user/actions/user.action';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [
    RouterOutlet
  ]
})
export class LayoutComponent implements OnInit {
    public isServer: boolean;

    constructor(
        @Inject(PLATFORM_ID) private _platformId: Object,
        private _store: Store<IAppState>,
    ) {
        this.isServer = isPlatformServer(this._platformId);
    }

    public ngOnInit(): void {
        this._store.dispatch(UserActions.fetch({}));
    }
}
